import XhrRequestHandler from '../../lib/XhrRequestHandler';
import { PlanillaPartido } from '../PlanillaPartido/PlanillaPartido';
import { TimeoutXPlanilla, TimeoutXPlanillaJSON } from './TimeoutXPlanilla';

export class TimeoutXPlanillaSystem {
  private readonly base = '/timeoutxplanillas';
  constructor(private requestHandler: XhrRequestHandler) {}

  async getTimeoutXPlanillaIdentifiedBy(id: string): Promise<TimeoutXPlanilla> {
    const data = await this.requestHandler.get<TimeoutXPlanillaJSON>(`${this.base}/${id}`);
    return TimeoutXPlanilla.fromJSON(data);
  }

  async getList(): Promise<TimeoutXPlanilla[]> {
    const data = await this.requestHandler.get<TimeoutXPlanillaJSON[]>(`${this.base}`);
    return data.map((entity) => TimeoutXPlanilla.fromJSON(entity));
  }

  async getListForDropdown(): Promise<TimeoutXPlanilla[]> {
    const data = await this.requestHandler.get<TimeoutXPlanillaJSON[]>(`${this.base}/for-dropdown`);
    return data.map((entity) => TimeoutXPlanilla.fromJSON(entity));
  }

  async save(entity: TimeoutXPlanilla) {
    const data = entity.toJSON();
    const savedEntity = await this.requestHandler.post<TimeoutXPlanillaJSON, TimeoutXPlanillaJSON>(
      this.base,
      data
    );
    return TimeoutXPlanilla.fromJSON(savedEntity);
  }

  async getListByPlanilla(planillaPartido: PlanillaPartido): Promise<TimeoutXPlanilla[]> {
    const data = await this.requestHandler.get<TimeoutXPlanillaJSON[]>(
      `${this.base}/planilla/${planillaPartido.getId()}`
    );
    return data.map((entity) => TimeoutXPlanilla.fromJSON(entity));
  }

  getBaseUrlForDatagrid() {
    return this.requestHandler.requestUrl(`${this.base}/datagrid`);
  }
}
